import React from 'react'
import Button from '../../../../../common/button/Button'
import useMemberTable from '../../context/MemberTableContext'
import { handleMembersConfirmationModal } from '../../Members/Utils'
import { modalBulkActionsId, modalBulkConfirmationMessageId } from './Utils'

const MembersAction = ({
  from,
  tableData,
  selectedLength,
  rowSelection
}) => {

  const { setSelectedBulkUser, setSelectedModal } = useMemberTable()
  const isPendingInvitesTable = from === 'Pending Invites Table'
  const isMembersTable = from === 'Members Table'
  const modalSetAsManager = isMembersTable
    ? modalBulkActionsId.members.setAsManager
    : isPendingInvitesTable && modalBulkActionsId.pendingInvites.setAsManager
  const modalSetAsMember = isMembersTable
    ? modalBulkActionsId.members.demoteToMember
    : isPendingInvitesTable && modalBulkActionsId.pendingInvites.setAsMember
  const modalDeleteRevokeUser = isMembersTable
    ? modalBulkActionsId.members.deleteUser
    : isPendingInvitesTable && modalBulkActionsId.pendingInvites.revokeInvitation
    
  const selectedRowData = () => {
    const filteredData = tableData?.filter((_, index) => rowSelection[index.toString()])
    return  filteredData
  }
  const selectedUsersData = { users: selectedRowData() }

  const isSelectedRoleExist = ( field = '' ) => {
    const isExist = selectedUsersData.users?.some( item => 
      item && isMembersTable 
      ? item.role.toLocaleLowerCase() === field.toLocaleLowerCase()
      : isPendingInvitesTable && item.invitationRole.toLocaleLowerCase() === field.toLocaleLowerCase()
    )
    return isExist
  }

  return (
    <div className={`msync-dropdown__panel__button-menu ${ selectedLength === 0 && 'msync-disabled'}`}>
        <Button
          className='msync-button--is-style-link msync-button--is-full-width'
          onClick={ () => handleMembersConfirmationModal( modalBulkConfirmationMessageId, { ...selectedUsersData, modal: modalSetAsManager }, null, setSelectedBulkUser, setSelectedModal  ) }
          isDisabled={ isSelectedRoleExist('owner') || isSelectedRoleExist('manager') || selectedLength === 0}
        >
          <span>Set as manager</span>
        </Button>
        <Button 
          className='msync-button--is-style-link msync-button--is-full-width'
          onClick={ () => handleMembersConfirmationModal( modalBulkConfirmationMessageId, { ...selectedUsersData, modal: modalSetAsMember }, null, setSelectedBulkUser, setSelectedModal  ) }
          isDisabled={ isSelectedRoleExist('owner') || isSelectedRoleExist('member') || selectedLength === 0 }
        >
          <span>{ from === 'Members Table' ? 'Demote to member' : 'Set as member' }</span>
        </Button>
      {
        isPendingInvitesTable &&
          <Button 
            className='msync-button--is-style-link msync-button--is-width-full'
            onClick={ () => handleMembersConfirmationModal( modalBulkConfirmationMessageId, { ...selectedUsersData, modal: modalBulkActionsId.pendingInvites.resendInvitation }, null, setSelectedBulkUser, setSelectedModal  ) }
            isDisabled={ selectedLength === 0 }
          >
            <span>Resend Invitation</span>
          </Button>
      }
        <Button
          className='msync-button--is-style-link msync-button--is-width-full msync-button--is-theme-destructive'
          onClick={ () => handleMembersConfirmationModal( modalBulkConfirmationMessageId, { ...selectedUsersData, modal: modalDeleteRevokeUser }, null, setSelectedBulkUser, setSelectedModal  ) }
          isDisabled={ selectedLength === 0 } 
        >
          <span>{ from === 'Members Table' ? 'Delete member' : 'Revoke Invitation' }</span>
        </Button>
    </div>
  )
}

export default MembersAction
